import { TFunction } from "i18next";
import _ from "lodash";
import {
  generateConsolidatedInvoiceURL,
  generateInvoiceURL,
} from "src/redux/slices/invoiceSlice";
import {
  ConsolidatedInvoiceStatuses,
  ConsolidatedInvoiceStatusesInNumbers,
  ContractStatuses,
  InvoiceStatuses,
  InvoiceStatusesInNumbers,
} from "src/resources/enum";
import { exportExcel, getFileName, reorderArrayOfObjects } from "./helpers";
import moment from "moment";

export function isContractActive(statusId: number | null): boolean {
  return statusId === ContractStatuses.Active;
}
export function isContractInactive(statusId: number | null): boolean {
  return statusId === ContractStatuses.Inactive;
}
export function isContractExpired(statusCode: number | null, contractStatuses: any): boolean {
  const status = contractStatuses?.find((x: { id: number }) => Number(x.id) === Number(statusCode));
  return status?.englishName?.toLowerCase() === "expired";
}
export const getSortedContractNumber = (
  contractDetails: any,
  contractStatuses: any
) => {
  if (!contractDetails) return [];
  const groupedContracts = _.groupBy(contractDetails, (contract) => {
    const isExpired = isContractExpired(contract?.statusCode, contractStatuses);
    if (isContractActive(contract?.statusId)) return "active";
    if (isContractInactive(contract?.statusId) && isExpired) return "expired";
    return "unassigned";
  });
  return _.flatMap(
    ["active", "expired", "unassigned"],
    (key) => groupedContracts[key] || []
  );
};

export const isSelectedFilterStatusIsCompleted = (
  statuses: any,
  selectedId: any
) => {
  const status = statuses?.find((x: { id: number }) => x.id == selectedId);
  if (
    status.englishName?.toLowerCase() == "completed" ||
    status.englishName?.toLowerCase() == "paid" ||
    status.englishName?.toLowerCase() == "refunded"
  ) {
    return true;
  } else return false;
};

export const generateInvoiceURLHandler = async (
  dispatch: (arg0: any) => any,
  invoiceID: any
) => {
  const paymentURL = await dispatch(generateInvoiceURL(invoiceID) as any);
  if (paymentURL) processPayment(paymentURL);
};
export const generateConsolidatedInvoiceURLHandler = async (
  dispatch: (arg0: any) => any,
  invoiceID: any
) => {
  const paymentURL = await dispatch(
    generateConsolidatedInvoiceURL(invoiceID) as any
  );
  if (paymentURL) processPayment(paymentURL);
};

const processPayment = (paymentURL: string): void => {
  try {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = paymentURL;
    document.body.appendChild(form);
    form.submit();
  } catch (error) {
    console.error("Payment error:", error);
  }
};
export const isConsolidatedInvoicePaid = (status: any) => {
  return (
    status === ConsolidatedInvoiceStatuses.PaymentCompleted ||
    Number(status) === ConsolidatedInvoiceStatusesInNumbers.PaymentCompleted
  );
};
export const isConsolidatedInvoiceNotPaid = (status: any) => {
  return (
    status === ConsolidatedInvoiceStatuses.NotPaid ||
    Number(status) === ConsolidatedInvoiceStatusesInNumbers.NotPaid
  );
};
export const isConsolidatedInvoicePGW = (status: any) => {
  return (
    status === ConsolidatedInvoiceStatuses.RedirectedToPGW ||
    Number(status) === ConsolidatedInvoiceStatusesInNumbers.RedirectedToPGW
  );
};

export const isInvoicePaid = (status: any) => {
  if (!status) return false;
  return (
    status === InvoiceStatuses.PaymentCompleted ||
    Number(status) === InvoiceStatusesInNumbers.PaymentCompleted
  );
};

export const isInvoicePGW = (status: any) => {
  return (
    status === InvoiceStatuses.RedirectedToPGW ||
    Number(status) === InvoiceStatusesInNumbers.RedirectedToPGW
  );
};

export const isInvoiceNotPaid = (status: any) => {
  return (
    status === InvoiceStatuses.NotPaid ||
    Number(status) === InvoiceStatusesInNumbers.NotPaid
  );
};

export function translateDataKeys(
  reorderedData: object[],
  t: TFunction<[string], undefined>
) {
  return reorderedData.map((item: any) => {
    const keys = Object.keys(item);
    return {
      ...keys.reduce((acc: { [key: string]: any }, key: string) => {
        acc[t(key)] = item[key];
        return acc;
      }, {}),
    };
  });
}

export const exportFormattedData = (
  mappedData: [],
  columns: string[],
  fileNamePrefix: string,
  t: any
) => {
  const reorderedData = reorderArrayOfObjects(mappedData, columns);
  const translatedData = translateDataKeys(reorderedData, t);
  const fileName = getFileName(fileNamePrefix);
  exportExcel(translatedData as [], fileName);
};
export function getCompanyPaymentStatus(status: any) {
  let paymentStatus = "";
  if (status === 0 || status === 1) {
    paymentStatus = "outstandingPayments";
  } else if (status === 2) {
    paymentStatus = "paymentsCleared";
  }
  return paymentStatus;
}

export const onHideCalendar = (calendarRef: any) => {
  if (calendarRef.current) {
    calendarRef.current?.getInput()?.blur();
  }
};
export const onShowCalendar = (calendarRef: any) => {
  if (calendarRef.current) {
    const dateValue = calendarRef.current?.getInput()?.value;
    if (!dateValue) {
      const calenderOverlay = calendarRef.current.getOverlay();
      const yearElement = calenderOverlay.querySelector(".p-datepicker-year");
      if (yearElement) {
        const currentYear = moment().year();
        yearElement.textContent = currentYear.toString();
      }
    }
  }
};
